import axios from "../../lib/axios";

export async function getReferrals() {
  const res = await axios.get("/referrals");
  return res.data.data;
}

export async function getReferralsRewards() {
  const res = await axios.get("/referrals/rewards");
  return res.data;
}
